import createCache from '@emotion/cache'

// MUI/Emotion defaults precede the tenant's JSS overrides on both server and
// client. The server creates one cache per render; the browser reuses its own.
export default function createEmotionCache() {
  return createCache({ key: 'css', prepend: true })
}
